var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReviewIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg-icon",
    style: {
      width: "1em",
      height: "1em",
      verticalAlign: "middle",
      fill: "currentColor",
      overflow: "hidden"
    },
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M803.126667 981.333333a21.253333 21.253333 0 0 1-9.926667-2.453333L512 831.046667l-281.2 147.833333a21.333333 21.333333 0 0 1-30.953333-22.486667l53.706666-313.12L26.053333 421.52a21.333333 21.333333 0 0 1 11.826667-36.386667l314.386667-45.686666L492.866667 54.56a21.333333 21.333333 0 0 1 38.266666 0l140.6 284.886667 314.386667 45.686666a21.333333 21.333333 0 0 1 11.826667 36.386667l-227.5 221.753333 53.706666 313.12a21.333333 21.333333 0 0 1-21.026666 24.94zM86.786667 421.14L291.333333 620.546667a21.333333 21.333333 0 0 1 6.14 18.886666l-48.266666 281.566667 252.866666-132.94a21.333333 21.333333 0 0 1 19.853334 0l252.866666 132.94-48.293333-281.566667a21.333333 21.333333 0 0 1 6.14-18.886666l204.573333-199.406667-282.72-41.086667a21.333333 21.333333 0 0 1-16.06-11.666666L512 112.206667 385.566667 368.386667a21.333333 21.333333 0 0 1-16.06 11.666666z",
    fill: "#5C5C66"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReviewIcon);
export default __webpack_public_path__ + "static/media/reviewIcon.59ebc0d59549b910c9c4b72b22b7841b.svg";
export { ForwardRef as ReactComponent };